import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=4288e0cc&scoped=true"
import script from "./noPermission.vue?vue&type=script&lang=js"
export * from "./noPermission.vue?vue&type=script&lang=js"
import style0 from "./noPermission.vue?vue&type=style&index=0&id=4288e0cc&prod&lang=scss"
import style1 from "./noPermission.vue?vue&type=style&index=1&id=4288e0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288e0cc",
  null
  
)

export default component.exports